import { Factory } from 'rosie';

Factory.define('SearchQuery')
  .attr('filter', {});


// WEBPACK FOOTER //
// ./factories/search_query_factory.js